import React from 'react';

const AgentInfo = ({ propertyData }) => {
  if (!propertyData || propertyData.status !== 'success' || !propertyData.data?.agent) {
    return null;
  }

  const agent = propertyData.data.agent;

  return (
    <div className="mt-6">
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
        <div className="p-5">
          <div className="flex items-center mb-4">
            <div className="w-8 h-8 bg-yellow-100 rounded-lg flex items-center justify-center mr-3">
              <svg className="w-4 h-4 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
            </div>
            <h4 className="text-lg font-semibold text-gray-900">Listing Agent</h4>
          </div>
          
          <div className="bg-gradient-to-r from-yellow-50 to-orange-50 p-4 rounded-lg border border-yellow-200 flex flex-col md:flex-row items-start md:items-center gap-4">
            {/* Agent Photo (Placeholder) */}
            <div className="w-16 h-16 bg-gray-200 rounded-full flex items-center justify-center overflow-hidden">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
            </div>
            
            {/* Agent Details */}
            <div className="flex-1">
              <div className="font-semibold text-lg text-gray-900">{agent.name}</div>
              <div className="text-sm text-gray-600">{agent.title} - {agent.agency}</div>
              <div className="mt-2 grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-1 text-sm">
                {agent.phone && (
                  <div>
                    <span className="font-medium">Phone:</span> {agent.phone}
                  </div>
                )}
                {agent.email && (
                  <div>
                    <span className="font-medium">Email:</span> {agent.email}
                  </div>
                )}
                {agent.experience && (
                  <div>
                    <span className="font-medium">Experience:</span> {agent.experience}
                  </div>
                )}
                {agent.rating && (
                  <div>
                    <span className="font-medium">Rating:</span> {agent.rating} ★
                  </div>
                )}
              </div>
            </div>
            
            {/* Contact Button */}
            <div className="w-full md:w-auto">
              <button 
                onClick={(e) => e.stopPropagation()}
                className="w-full md:w-auto px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white rounded-lg text-sm font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 shadow-sm"
              >
                Contact Agent
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgentInfo;